import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"

const CPFProperties = ({ onUpdate, onChangeSettings, settings }) => {
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      cpfBuilding: (settings && settings.cpfBuilding) || "",
      // carparkQuotaAlert: (settings && settings.carparkQuotaAlert) || "",
    },
    validationSchema: Yup.object({
      cpfBuilding: Yup.string().required("Please Enter Value"),
      // carparkQuotaAlert: Yup.string().required("Please Enter Value").matches(/^[0-9]+$/i, "Invalid value!"),
    }),
    onSubmit: values => {
      if (values) {
        const modifiedData = { ...settings }
        modifiedData["cpfBuilding"] = values["cpfBuilding"]
        // modifiedData["carparkQuotaAlert"] = values["carparkQuotaAlert"]
        onChangeSettings("cpfProperties", modifiedData)
      }
    },
  })

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 card-title">
            <i className="bx bx-buildings text-primary align-bottom font-size-24 me-2"></i>
            CPF Properties
          </div>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row>
              <div className="mb-3">
                <Label htmlFor="formrow-firstname-Input" className="form-label">
                  List of CPF Buildings*
                </Label>
                <Input
                  name="cpfBuilding"
                  value={validation.values.cpfBuilding || ""}
                  id="cpfBuilding-input"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.cpfBuilding &&
                    validation.errors.cpfBuilding
                      ? true
                      : false
                  }
                />
                {validation.touched.cpfBuilding &&
                validation.errors.cpfBuilding ? (
                  <FormFeedback type="invalid">
                    {validation.errors.cpfBuilding}
                  </FormFeedback>
                ) : null}
                <span className="badgecount text-muted">
                  Seperate each input with a comma
                </span>
              </div>

              {/* <Col md={4}>
                <div className="mb-3">
                  <Label
                    htmlFor="formrow-password-Input"
                    className="form-label"
                  >
                    Carpark Quota Alert
                  </Label>
                  <div className="input-group">
                    <Input
                      name="carparkQuotaAlert"
                      value={validation.values.carparkQuotaAlert || ""}
                      id="carparkQuotaAlert-Input"
                      type="text"
                      style={{ textAlign: "right" }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.carparkQuotaAlert &&
                        validation.errors.carparkQuotaAlert
                          ? true
                          : false
                      }
                    />
                    <button
                      type="button"
                      id=""
                      className="btn btn-border"
                      style={{
                        border: "1px solid #ced4da",
                        borderLeft: "1px solid #fff",
                      }}
                    >
                      %
                    </button>
                  </div>
                  {validation.touched.carparkQuotaAlert &&
                  validation.errors.carparkQuotaAlert ? (
                    <FormFeedback type="invalid">
                      {validation.errors.carparkQuotaAlert}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col> */}
            </Row>
            <div className="mb-3"></div>
            <div>
              <button
                type="submit"
                //onClick={onUpdate}
                className="btn btn-primary w-md"
              >
                Update
              </button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

CPFProperties.propTypes = {
  onUpdate: PropTypes.func,
  onChangeSettings: PropTypes.func,
  settings: PropTypes.any,
}

export default CPFProperties
